// extracted by mini-css-extract-plugin
export default {"header":"styles_header__AWo-h","header_data":"styles_header_data__zmYHs","name":"styles_name__vpWnG"};